import { ProfileService } from 'client/services';

const loader = async ({ request }) => {
    const url = new URL(request.url);
    url.searchParams.set('hidden', 'false');
    const bookmarks = await ProfileService.getBookmarks(url.searchParams);
    return { bookmarks };
};

export default loader;
